import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const Container = muiStyled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  width: "100%",
  backgroundColor: "var(--dp-surface)",
  border: "1px solid var(--dp-border)",
  boxShadow: "0 0 15px 0px rgb(0 0 0 / 10%)",
  padding: "32px 24px",
  borderRadius: "10px",
});

export const ContainerButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

export const Title = styled.p`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  margin-bottom: 8px;
`;

export const Description = styled.p`
  font-size: 0.8rem;
  font-weight: 400;
  margin: 0;
  margin-bottom: 16px;
`;
